module.exports = __webpack_public_path__ + "static/far-cry_fullpage-2fcac1e9cf5c76896d53c271cbe8a332.avif";